module.exports = {
	round(value, digits = 2, type = 'floor') {
		if (typeof value === 'number') {
			let multiplier = Math.pow(10, digits);
			return Math[type](value * multiplier) / multiplier;
		}
		return null;
	}
};
